import Icon from '@atoms/Icon/Icon';
import NavigationItem from '@atoms/NavigationItem/NavigationItem';
import useLocale from '@hooks/useLocale';
import { SolutionsMenuItem } from '@type-declarations/menu';
import { NavigationItem as NavigationItemProps } from '@type-declarations/navigationItem';
import isSolutionsMainMenuItem from '@utils/isSolutionsMenuItem';
import isValidLink from '@utils/isValidLink';
import clsx from 'clsx';

import MegaMenu from './MegaMenu';
import styles from './Navbar.module.scss';

interface Props {
  menu: NavigationItemProps[];
  currentPageId?: string;
  solutionsMenuItems?: SolutionsMenuItem[];
}

export default function Navbar({
  menu,
  currentPageId,
  solutionsMenuItems = [],
}: Props) {
  const locale = useLocale();
  const megaMenuItems = solutionsMenuItems.filter(isValidLink);

  return (
    <div className={styles.navbarWrapper}>
      <ul className={clsx(styles.navbar, 'u-list-clean')}>
        {menu.filter(isValidLink).map(menuItem => {
          const linkPageID = menuItem.internalLink?.page[0]?.id;
          const isActive = linkPageID === currentPageId;
          const hasMegaMenu =
            isSolutionsMainMenuItem(menuItem, locale) &&
            megaMenuItems.length > 0;
          return (
            <li
              className={clsx(
                styles.listItem,
                isActive && styles.active,
                hasMegaMenu && styles.hasMegaMenu,
              )}
              key={menuItem.id}
            >
              <div className={styles.navItemContainer}>
                <NavigationItem
                  item={menuItem}
                  className={clsx(styles.navbarItem, isActive && styles.active)}
                />

                {hasMegaMenu && (
                  <div className={styles.dropdownIcon}>
                    <Icon icon="chevron-down" />
                  </div>
                )}
              </div>

              {hasMegaMenu && <MegaMenu menuItems={megaMenuItems} />}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
